import React, { useState } from "react";
import * as styles from './StarRating.module.css'
import Icon from '../../atoms/Icon/Icon';

const StarRating = ({rating, setRating}) => {
//   const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(0);

  return (
    <div className={styles.starsContainer}>
      {[...Array(5)].map((star, index) => {
        index += 1;
        return (
            <div
                className={`${styles.star} ${index <= (hover || rating) ? styles.active : styles.inactive}`}
                key={index}
                onClick={() => setRating(index)}
                onMouseEnter={() => setHover(index)}
                onMouseLeave={() => setHover(rating)}
                role={'presentation'}
            >
                <Icon symbol={'star'}></Icon>
            </div>
        );
      })}
    </div>
  );
};

export default StarRating;